import React, { FC } from 'react'

interface IQuestionIconProps {
  className: string
}

const QuestionIcon: FC<IQuestionIconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Vector"
        d="M26.14 18.5L24.34 20.34C22.9 21.78 22 23 22 26H18V25C18 22.78 18.9 20.78 20.34 19.34L22.82 16.82C23.56 16.1 24 15.1 24 14C24 11.78 22.2 10 20 10C18.9391 10 17.9217 10.4214 17.1716 11.1716C16.4214 11.9217 16 12.9391 16 14H12C12 11.8783 12.8429 9.84344 14.3431 8.34315C15.8434 6.84285 17.8783 6 20 6C22.1217 6 24.1566 6.84285 25.6569 8.34315C27.1571 9.84344 28 11.8783 28 14C28 15.76 27.28 17.34 26.14 18.5ZM22 34H18V30H22M20 0C17.3736 0 14.7728 0.517315 12.3463 1.52241C9.91982 2.5275 7.71504 4.00069 5.85786 5.85786C2.10714 9.60859 0 14.6957 0 20C0 25.3043 2.10714 30.3914 5.85786 34.1421C7.71504 35.9993 9.91982 37.4725 12.3463 38.4776C14.7728 39.4827 17.3736 40 20 40C25.3043 40 30.3914 37.8929 34.1421 34.1421C37.8929 30.3914 40 25.3043 40 20C40 8.94 31 0 20 0Z"
        fill="white"
      />
    </svg>
  )
}

export default QuestionIcon
